// extracted by mini-css-extract-plugin
module.exports = {"page":"Contact_page__5CABN","contactInfo":"Contact_contactInfo__N6XJu"};